<template>
    <a-modal v-model="visible22" title="新增易制爆证件" width="1020px" :footer="null">
        <div>
            <div style="height:20px;border-bottom:1px solid #2B9A34;color:#2B9A34;width:200px">易制爆危险化学品合法用途说明</div>
            <a-form-model>
                <a-row class="form-row" :gutter="24">
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="购买单位" prop="name">
                            <a-input v-model="subject" :disabled="true" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="经办人姓名" prop="name">
                            <a-input v-model="agent" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="经办人身份证" prop="name">
                            <a-input v-model="agentIdcard" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="购买时间" prop="name">
                            <a-date-picker style="width: 100%;" v-model="buyTime" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="购买用途" prop="name">
                            <a-input v-model="useBuy" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 12 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="过期日期" prop="name">
                            <div style="display:flex">
                                <a-form-model-item style="width:48%;margin:0 10px 0 0">
                                    <a-date-picker style="width: 100%;" v-model="expirationTime" />
                                </a-form-model-item>
                            </div>
                        </a-form-model-item>
                    </a-col>
                    <a-col :xl="{ span: 24 }" :lg="{ span: 6 }" :md="{ span: 12 }" :sm="24">
                        <a-form-model-item ref="name" label="证书扫描件" prop="name">
                            <img-upload ref="upload" />
                            <!-- :idList="item" -->
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            <div style="margin:20px 0;">批准购买产品内容</div>
            <div style="width:100%; display: flex;justify-content: space-between;background: #F4F4F4;height:40px;line-height: 40px;padding:0 20px">
                <span>商品名</span>
                <span>CAS号</span>
                <span>数量</span>
                <span>单位</span>
                <span style="width:40px">操作</span>
            </div>
            <div v-for="(item, i) in cunshuju" :key="i" style="width:100%; display: flex;justify-content: space-between;height:40px;line-height: 40px;padding:0 20px;margin:10px 0;background:#E8E6E6">
                <a-input style="width:120px;margin-top:4px" :disabled="item.isdisabled" v-model="item.name" />
                <a-input style="width:120px;margin-top:4px" :disabled="item.isdisabled" v-model="item.casNum" />
                <a-input style="width:120px;margin-top:4px" :disabled="item.isdisabled" type="number" v-model="item.quantity" />
                <!-- <a-input style="width:120px;margin-top:4px" :disabled="item.isdisabled" v-model="item.unit" /> -->
                <a-select v-model="item.unit" default-value="g" style="width:120px;margin-top:4px">
                    <a-select-option v-for="int in list_unit" :key="int" :value="int">{{ int }}</a-select-option>
                </a-select>
                <div>
                    <a-button v-if="item.isdisabled === true" @click="item.isdisabled = false">修改</a-button>
                    <a-button v-else @click="item.isdisabled = true">保存</a-button>
                    <a-button @click="del(i)">删除</a-button>
                </div>
            </div>
            <div style="width:100%; display: flex;justify-content: space-between;height:40px;line-height: 40px;padding:0 20px;margin:10px 0;background:#E8E6E6">
                <a-input style="width:120px;margin-top:4px" v-model="kongshuju.name" />
                <a-input style="width:120px;margin-top:4px" v-model="kongshuju.casNum" />
                <a-input style="width:120px;margin-top:4px" type="number" v-model="kongshuju.quantity" />
                <!-- <a-input style="width:120px;margin-top:4px" v-model="kongshuju.unit" /> -->
                <a-select v-model="kongshuju.unit" default-value="g" style="width:120px;margin-top:4px">
                    <a-select-option v-for="int in list_unit" :key="int" :value="int">{{ int }}</a-select-option>
                </a-select>
                <div>
                    <a-button @click="tianjiakong">保存</a-button>
                    <a-button type="dashed">清空</a-button>
                </div>
            </div>
            <!-- 添加空数组 -->
            <!-- <a-button @click="tianjia" type="dashed" style="margin:20px 0 30px 0" block>
        添加
      </a-button> -->
            <a-button type="primary" @click="sub" style="margin-left:450px">
                保存
            </a-button>
        </div>
    </a-modal>
</template>
<script>
import ImgUpload from './ImgUpload';
export default {
    components: {
        ImgUpload
    },
    data() {
        return {
            list_unit: ['ton', 'kg', 'g', 'mg', 'L', 'ml'],
            visible22: false,
            agent: '',
            cunshuju: [], //数组存放商品的数据
            disabled1: true,
            kongshuju: {
                unit: '',
                quantity: null,
                name: '',
                casNum: '',
                isdisabled: true
            },
            //
            buyTime: '',
            expirationTime: '',
            agentIdcard: '',
            useBuy: '',
            scanList: [],
            subject: '',
            userId: '',
            // 返回的uuid
            zhenshuUuid: ''
        };
    },
    created() {
        const getUserinfo = JSON.parse(localStorage.user_info);
        this.userId = getUserinfo.uuid;
        this.api.get_companyFullName().then(res => {
            this.subject = res.data;
            // if (res.data === null) {
            //   this.$router.push('/enterprise_info')
            //   this.$message.error('请前往企业信息完成内容填写')
            // }
        });
    },
    methods: {
        tianjiakong() {
            this.cunshuju.push({ ...this.kongshuju });
            this.kongshuju.unit = '';
            this.kongshuju.quantity = null;
            this.kongshuju.name = '';
            this.kongshuju.casNum = '';
        },
        crea() {
            this.kongshuju.unit = '';
            this.kongshuju.quantity = null;
            this.kongshuju.name = '';
            this.kongshuju.casNum = '';
        },
        del(e) {
            this.cunshuju.splice(e, 1);
        },
        sub() {
            const img = this.$refs['upload'].list
                .filter(item => item.id)
                .map(item => {
                    return {
                        id: item.id
                    };
                });
            const scanList = [];
            for (let i = 0; i < img.length; i++) {
                scanList[i] = img[i].id;
            }
            const list = {
                agent: this.agent,
                agentIdcard: this.agentIdcard,
                useBuy: this.useBuy,
                allowList: this.cunshuju,
                buyTime: this.buyTime,
                expirationTime: this.expirationTime,
                scanList: scanList,
                subject: this.subject,
                userId: this.userId
            };
            this.api.pushYizhibao(list).then(res => {
                if (res.ok === true) {
                    this.$message.success(res.message);
                    this.zhenshuUuid = res.data.uuid;
                    console.log(this.zhenshuUuid, '新增的证书uuid');
                    this.visible22 = false;
                    this.$emit('child-event', res.data.uuid);
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    }
};
</script>

<style scoped>
/deep/.ant-form-item {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImgUpload/XyizhiBao.vue